<script>
  import Icon from "./Icon.svelte";
</script>

<div class="row padding-10 logo-div">
  {#if !['/', '/otp-login', '/choose-number'].includes(window.location.pathname)}
    <div class="mr-10">
      <Icon icon="logo-brand" />
    </div>
  {/if}

  <div class="brand-name">PressOne</div>
</div>

<style>
  .logo-div {
    background-color: #FFF7E4;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding-top: 19px;
    padding-bottom: 19px; */
  }

  .brand-name {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 0;
    /* background: #FFFBF1; */
    font-family: 'Recoleta';
    font-weight: 700;
    font-size: 20px;
  }
</style>
